/**
 * Состояние карты для возврата из тура (E4.6b): масштаб и сдвиг -- то, чего нет в адресе
 * (поиск, фильтры и выбранный узел адрес восстанавливает сам). Карта,
 * пока смонтирована, отдаёт и принимает его через адаптер; если карты на экране нет,
 * значение ждёт её монтирования. Это не второе хранилище карты: адаптер только снимает и
 * возвращает поля её собственного состояния.
 */

import type { MapTransform } from '@/pages/DataMap/types';

export interface MapReturnState {
	/** Вид карты; null — исходный (вписанная сцена или ключевой контур) */
	transform: MapTransform | null;
}

export interface MapStateAdapter {
	capture: () => MapReturnState;
	restore: (value: MapReturnState) => void;
}

let adapter: MapStateAdapter | null = null;
let pending: MapReturnState | null = null;

/** Карта подключает адаптер на время монтирования; ожидающее значение применяется сразу */
export function registerMapStateAdapter(next: MapStateAdapter): () => void {
	adapter = next;
	if (pending !== null) {
		next.restore(pending);
		pending = null;
	}
	return () => {
		if (adapter === next) adapter = null;
	};
}

/** Снимок карты на экране; null -- карты нет */
export function captureMapState(): MapReturnState | null {
	return adapter?.capture() ?? null;
}

export function restoreMapState(value: MapReturnState): void {
	if (adapter) adapter.restore(value);
	else pending = value;
}

/** Возврат без карты: ожидающее значение больше не нужно */
export function forgetMapState(): void {
	pending = null;
}
